import { View, Text, StyleSheet } from 'react-native'
import { mesaColorNames, typography } from '@/src/common/theme'
import { formatNumber, formatCurrency } from '@/src/common/utils/general'
import { DesignSystem } from '@/src/design-system'
import { Skeleton } from 'moti/skeleton'

export function PointsRedemptionConfirmationInfoCard({
  pointsToRedeem,
  remainingPoints,
  creditAmount,
  conversionRate,
}: {
  pointsToRedeem: number
  remainingPoints: number | 'loading'
  creditAmount: number
  conversionRate: string
}) {
  return (
    <DesignSystem.Card style={styles.whiteBlock}>
      <View style={styles.infoContainer}>
        <View style={[styles.infoSection, styles.infoSectionBorder]}>
          <Text style={styles.infoHeader}>Redeem</Text>
          <Text style={typography['label/md-bold']}>
            {formatNumber(pointsToRedeem)} Mesa Points
          </Text>
        </View>
        <View style={[styles.infoSection, styles.infoSectionBorder]}>
          <Text style={styles.infoHeader}>Receive</Text>
          <Text style={typography['label/md-bold']}>
            {formatCurrency(`${creditAmount}`, { isFloat: true, decimals: null })}
          </Text>
        </View>
        <View style={[styles.infoSection, styles.infoSectionBorder]}>
          <Text style={styles.infoHeader}>Conversion Rate</Text>
          <Text style={typography['label/md-bold']}>{conversionRate}</Text>
        </View>
        <View style={[styles.infoSection]}>
          <Text style={styles.infoHeader}>Remaining Mesa Points</Text>
          {remainingPoints === 'loading' ? (
            <Skeleton colorMode="light" height={16} width={88} />
          ) : (
            <Text style={typography['label/md-bold']}>
              {formatNumber(Number(Math.max(0, remainingPoints)))}
            </Text>
          )}
        </View>
      </View>
    </DesignSystem.Card>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'],
    paddingHorizontal: 14,
    gap: 32,
    color: mesaColorNames['global/grey/80 #2F3133'],
  },
  whiteBlock: {
    borderRadius: 12,
    padding: 16,
    gap: 24,
  },
  infoContainer: {
    gap: 16,
  },
  infoSection: {
    gap: 8,
    padding: 4,
  },
  infoSectionBorder: {
    borderBottomWidth: 1,
    borderBottomColor: mesaColorNames['semantic/bg/disabled #DADDDE'],
    paddingBottom: 16,
  },
  infoHeader: {
    ...typography['label/sm-regular'],
    color: mesaColorNames['Greyscale/500 #6E7375'],
  },
})
